<section id="noapp" class="noapp">
  <div class="wl-inner inner">
    <div class="row">
      <div class="qr-tile">
        <svg width="68" height="68" viewBox="0 0 24 24" fill="none" stroke="#1A1713" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><line x1="14" y1="14" x2="14" y2="14.01"/><line x1="21" y1="14" x2="21" y2="14.01"/><line x1="14" y1="21" x2="14" y2="21.01"/><line x1="21" y1="21" x2="21" y2="21.01"/><line x1="17.5" y1="17.5" x2="17.5" y2="17.51"/></svg>
      </div>
      <div class="text">
        <p class="eyebrow">Zero instalacji</p>
        <h2 class="title">Żadnej aplikacji do pobierania.</h2>
        <p class="sub">Goście skanują kod QR telefonem i grają od razu. Wszystko działa w przeglądarce. Bez sklepu z aplikacjami, bez zakładania konta, bez czekania.</p>
      </div>
    </div>
  </div>
</section>
